export const typography = {
    fontFamily: "Open Sans",
    h1: { fontSize: "96px", fontWeight: 300, lineHeight: "112px" },
    h2: { fontSize: "60px", fontWeight: 300, lineHeight: "62px" },
    h3: { fontSize: "48px", fontWeight: 400, lineHeight: "56px" },
    h4: { fontSize: "34px", fontWeight: 400, lineHeight: "41.99px", letterSpacing: "0.25px" },
    h5: { fontSize: "22px", fontWeight: 400, lineHeight: "29.3px" },
    h6: { fontSize: "18px", fontWeight: 400, lineHeight: "21.6px" },
    subtitle1: { fontSize: "16px", fontWeight: 500, lineHeight: "28px" },
    subtitle2: { fontSize: "14px", fontWeight: 500, lineHeight: "22px" },
    body1: { fontSize: "14px", fontWeight: 400, lineHeight: "21px" },
    body2: { fontSize: "14px", fontWeight: 400, lineHeight: "20px" },
    caption: { fontSize: "12px", fontWeight: 400, lineHeight: "20px" },
    overline: { fontSize: "12px", fontWeight: 400, lineHeight: "32px", textTransform: "capitalize" },
    label: { fontSize: "10.5px", fontWeight: 400, lineHeight: "18px", letterSpacing: "0.11px", marginTop: "-1.7px", marginLeft: "0.5px" },
    input: { fontSize: "14px", fontWeight: 400, lineHeight: "1.4375em", padding: "5px 0" },
    inputLabel: { fontSize: "12px", fontWeight: 400, lineHeight: "12px" },
    tooltip: { fontSize: "12px", fontWeight: 400, lineHeight: "14px" },
    tooltipEditor: { fontSize: "12px", fontWeight: 400, lineHeight: "auto" },
    helper: { fontSize: "12px", fontWeight: 400, lineHeight: "20px", letterSpacing: "0.4px" }
};
//# sourceMappingURL=typography.js.map